import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { useAuth } from "../../../context/AuthContext";
import { X } from "@phosphor-icons/react";

const empty = { name: "", email: "", password: "", role: "employee", department: "", designation: "", phone: "", date_of_joining: "", shift: "General" };

export const AddEmployeeModal = ({ deps, onClose, onCreated }) => {
  const { user } = useAuth();
  const [form, setForm] = useState(empty);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/employees", form);
      toast.success("Employee created");
      onCreated();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-0 sm:p-6" onClick={onClose}>
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl font-bold">New employee</h2>
          <button onClick={onClose} data-testid="close-employee-modal"><X size={22} /></button>
        </div>
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[["name", "Full name", "text", true], ["email", "Email (optional)", "email", false], ["password", "Initial password", "text", true],
            ["designation", "Designation", "text", false], ["phone", "Phone", "text", false], ["date_of_joining", "Date of joining", "date", false]].map(([k, label, type, req]) => (
            <div key={k} className={k === "name" || k === "email" ? "sm:col-span-2" : ""}>
              <label className="text-sm font-semibold text-stone-700">{label}</label>
              <input type={type} required={req} value={form[k]} onChange={set(k)} data-testid={`employee-form-${k}`}
                className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
          ))}
          <div>
            <label className="text-sm font-semibold text-stone-700">Department</label>
            <select value={form.department} onChange={set("department")} data-testid="employee-form-department" className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
              <option value="">Select…</option>
              {deps.map((x) => <option key={x.id} value={x.name}>{x.name}</option>)}
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-stone-700">Role</label>
            <select value={form.role} onChange={set("role")} data-testid="employee-form-role" className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
              <option value="employee">Employee</option>
              <option value="hr_admin">HR/Admin</option>
              {user?.role === "super_admin" && <option value="super_admin">Super Admin</option>}
            </select>
          </div>
          <button type="submit" data-testid="employee-form-submit" className="sm:col-span-2 tap-scale min-h-[48px] rounded-full bg-primary text-white font-bold hover:bg-[#A63F07] transition-colors duration-200">Create employee</button>
        </form>
      </div>
    </div>
  );
};
